import React, { memo, useState } from "react";
import { Person, Phone } from "@mui/icons-material";
import { TextField } from "@mui/material";
import { carColor } from "../common/bookingUtils";
import { Booking } from "../../../models/booking";
import "../../../../styles/commonStyle.css"
import { updateBookingField } from '../../../services/BookingService';
import CustomHeader from "../common/CustomHeader"

interface BookingCancelProps {
  booking: Booking;
}

const BookingCancel: React.FC<BookingCancelProps> = ({ booking }) => {

  const [modalOpen, setModalOpen] = useState(false);

  const handleUpdate = async (booking: Booking) => {
    const phone = "(+91)8600572727";
    const updatedPhone = phone.replace(/\D/g, '');
    const message = `Booking Cancellation Request\nBookingId : ${booking.bookingId}\nReason for Cancellation :  `;
    const encodedMessage = encodeURIComponent(message);

    const url = `https://api.whatsapp.com/send?phone=${updatedPhone}&text=${encodedMessage}`;
    window.open(url, '_blank');


  };

  return (
    <>
      {/* <div className="bg-white border rounded shadow-sm px-4 py-2 mt-1 text-start" style={{ fontFamily: "Segoe UI, sans-serif", }}>
        <div className="mb-3 "> */}
      <div className="d-flex justify-content-between align-items-center">
        {/* <h6 className="fw-bold text-uppercase text-center mb-4" style={{ fontSize: "0.875rem" }}>
          Cancel Booking
        </h6> */}
      </div>
      <button
        type="button"
        className="btn btn-outline-secondary w-100 my-2"
        onClick={() => handleUpdate(booking)}
      >
        Cancel Booking
          </button>
      {/* </div>
      </div> */}


      {modalOpen && (
        <div className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <CustomHeader value={"Cancel Your Booking"}></CustomHeader>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>


              <div className="modal-body">

              </div>

              <div className="modal-footer">
                <div className="d-flex justify-content-end w-100 gap-2">
                  <button
                    type="button"
                    className="btn back-button w-50"
                    onClick={() => setModalOpen(false)}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn primary-button w-50"
                    onClick={() => handleUpdate(booking)}
                  >
                    Yes
                  </button>
                </div>
              </div>



            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(BookingCancel);